import React, { useRef, useState } from "react";
import { Button, Input, Space, Table } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import moment from "moment-jalaali";
import { separate } from "../../../Utils/SeprateNumber/SeprateThreeNumber";

const BarestHelpTabel = ({ modalHandler, data }) => {
  const searchInput = useRef(null);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const getColumnSearchProps = (dataIndex, title) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`جستجو ${title}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            جستجو
          </Button>
          <Button
            onClick={() => handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            پاکسازی
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };
  const columns = [
    {
      title: "شماره",
      dataIndex: "id",
      key: "id",
      ...getColumnSearchProps("id", "شماره درخواست"),
    },
    {
      title: "نام کاربر",
      dataIndex: "full_name",
      key: "full_name",
      ...getColumnSearchProps("full_name", "نام کاربر"),
    },
    {
      title: "آیدی کاربر",
      dataIndex: "user_id",
      key: "user_id",
      ...getColumnSearchProps("user_id", "شماره کاربر"),
    },
    {
      title: "مبلغ (تومان)",
      dataIndex: "amount",
      key: "amount",
      ...getColumnSearchProps("amount", "هزینه"),
      render: (text) =><p style={{color:"green"}}>{separate(text)}</p>
    },
    {
      title: "تاریخ درخواست",
      dataIndex: "date",
      key: "date",
      ...getColumnSearchProps("date", "تاریخ درخواست"),
      render: (text) =><p style={{color:"green"}}>{moment
                    .unix(parseInt(text))
                    .format("jYYYY/jM/jD--HH:mm")}</p>
    },

    {
      title: "عملیات",
      dataIndex: "action",
      key: "action",
      render: (text, record) => (
        <Button type="primary" onClick={()=>modalHandler(record)}>تراکنشات</Button>
      ),
    },
  ];
  return (
    <div style={{ width: "100%" }}>
      <Table
        pagination={{ pageSize: 8 }}
        columns={columns}
         dataSource={data?.map(item => ({ ...item, key: item.id }))}
      />
    </div>
  );
};

export default BarestHelpTabel;
